<script setup lang="ts">
import type { MessageFrom } from '@/types'
import { computed } from 'vue'
import moment from 'moment'

const props = withDefaults(
  defineProps<{
    from?: MessageFrom
    content?: string
    timestamp?: number
    showHeader?: boolean
  }>(),
  {
    from: 'self',
    showHeader: false,
  }
)
const sendTime = computed(() => {
  return props.timestamp ? moment(props.timestamp).format('YYYY/MM/DD HH:mm') : ''
})
</script>

<template>
  <div class="message-plain clearfix" :class="[from]">
    <img
      :style="{ visibility: showHeader ? 'visible' : 'hidden' }"
      class="pull-left header"
      v-if="from === 'other'"
      src="~@/assets/images/icon-robot-header.png"
    />
    <div class="content">
      <div class="content__inner">
        <slot>{{ content }}</slot>
      </div>
      <slot name="details" />
      <div class="send-time">{{ sendTime }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.message-plain {
  margin-bottom: 1.12rem;
  $pout: 0.56rem;
  $pin: 0.533rem;

  .send-time {
    color: #999;
    line-height: 1.2rem;
  }

  .content {
    max-width: 14rem;

    &__inner {
      display: inline-block;
      padding: 0.56rem 0 0.613rem;
      box-shadow: 0 0.05rem 0.11rem 0 #e0e5f0;
      border-radius: 0.64rem;
    }
  }

  .header {
    $size: 2.13rem;
    width: $size;
    height: $size;
    border-radius: $size;
    display: block;
    margin-right: 0.507rem;
  }

  &.self {
    .content {
      float: right;
      color: #fff;
      text-align: right;

      &__inner {
        padding-left: $pout;
        padding-right: $pin;
        background: #00bcff;
        border-top-right-radius: 0;
        text-align: left;
      }
    }
  }

  &.other {
    .content {
      float: left;

      &__inner {
        padding-left: $pin;
        padding-right: $pout;
        background: #eff3fc;
        border-top-left-radius: 0;
      }
    }
  }
}
</style>
